import React from "react";

export interface INewsletterContext {
  newsletterOpen: boolean;
  setNewsletterOpen: (open: boolean) => void;
}

export const NewsletterContext = React.createContext<INewsletterContext>({
  newsletterOpen: false,
  setNewsletterOpen: () => {},
});

export const useNewsletter = () => React.useContext(NewsletterContext);

export const NewsletterProvider = ({ children }: { children: React.ReactNode }) => {
  const [newsletterOpen, setNewsletterOpen] = React.useState(false);

  return (
    <NewsletterContext.Provider value={{ newsletterOpen, setNewsletterOpen }}>
      {children}
    </NewsletterContext.Provider>
  );
};
